export enum ResponseCodes {
    OK = "OK",
    NO_ACTIVE_SESSION = "NO_ACTIVE_SESSION",
    INVALID_TOKEN = "INVALID_TOKEN",
    EXPIRED_TOKEN = "EXPIRED_TOKEN",
    PENDING_VERIFY_2FA = "PENDING_VERIFY_2FA"
}